import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { toast } from 'react-toastify';
import airfreightratesServices from '../../Services/airfreightratesServices'
import Loader from '../../Components/Loader'
import { PhoneCode } from '../../Components';

const UsersTypeList = [{ value: 'Courier_Users', label: 'India' }]

export const AddUser = () => {

    const [loader, setLoader] = useState(false)

    const history = useHistory()
    const formik = useFormik({
        initialValues: {
            Users_name: '',
            confirm_account_number: '',
            account_number: '',
            nationality: '',
            contact_number: '',
            normal_amount: '',
            full_name: '',
            Users_email: '',
            Users_business_ddress: '',
            taxation_details: '',
            rate_cards: '',
            account_holder_name: '',
            branch_address: '',
            branch_name: '',
            routing_number: ''
        },
        validationSchema: Yup.object({
            Users_name: Yup.string().required('Required'),
            confirm_account_number: Yup.string().required('Required'),
            account_number: Yup.string().required('Required'),
            nationality: Yup.string().required('Required'),
            contact_number: Yup.string().required('Required'),
            normal_amount: Yup.string().required('Required'),
            full_name: Yup.string().required('Required'),
            Users_email: Yup.string().required('Required'),
            Users_business_ddress: Yup.string().required('Required'),
            taxation_details: Yup.string().required('Required'),
            rate_cards: Yup.string().required('Required'),
            account_holder_name: Yup.string().required('Required'),
            branch_address: Yup.string().required('Required'),
            branch_name: Yup.string().required('Required'),
            routing_number: Yup.string().required('Required'),

        }),
        onSubmit: values => {
            setLoader(true)
            let postData = {
                ...values,
                Users_email:values.Users_email.toLowerCase()
            }
            airfreightratesServices.addAirfreightrates(postData).then(res => {
                if (res.status) {
                    setLoader(false)
                    history.push('/air-freight-rate-list')
                } else {
                    setLoader(false)
                    toast.error(res.message)
                }
            })
        },
    });

    

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Name</label>
                                    <input
                                        required={false}
                                        type="text"
                                        className={'form-control' + (formik.touched.Users_name ? !formik.errors.Users_name ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('Users_name')}
                                        placeholder="Enter name"
                                    />
                                    {formik.touched.Users_name && formik.errors.Users_name ? (
                                        <div className="text-danger">{formik.errors.Users_name}</div>
                                    ) : null}
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Email</label>
                                    <input
                                        type="email"
                                        className={'form-control' + (formik.touched.Users_email ? !formik.errors.Users_email ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('Users_email')}
                                        placeholder="Enter Email"
                                    />
                                    {formik.touched.Users_email && formik.errors.Users_email ? (
                                        <div className="text-danger">{formik.errors.Users_email}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Contact No.</label>
                                    <div
                                            className={(formik.touched.contact_number ? !formik.errors.contact_number ? ' contact-success' : ' contact-error' : '')}
                                        >
                                            <PhoneCode
                                                Addphone={(value) => formik.setValues({ ...formik.values, contact_number: value })}
                                                phone={formik.values.contact_number}
                                            />
                                        </div>
                                    <input
                                        required={false}
                                        type="number"
                                        min="0"
                                        className={'form-control' + (formik.touched.contact_number ? !formik.errors.contact_number ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('contact_number')}
                                        placeholder="Enter Contact Number"
                                    />
                                    {formik.touched.contact_number && formik.errors.contact_number ? (
                                        <div className="text-danger">{formik.errors.contact_number}</div>
                                    ) : null}
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label" >Nationality</label>
                                    <Select
                                        styles={{
                                            valueContainer: (provided) => ({
                                                ...provided,
                                                height: 'calc(2.15rem + 2px)',
                                                overflowY: 'visible'
                                            }),
                                            control: (provider) => ({
                                                ...provider,
                                                borderColor: formik.touched.nationality ? !formik.errors.nationality ? '#34c38f' : '#f46a6a' : '#ced4da',
                                                boxShadow: '0 0 0 0px #f46a6a'
                                            }),
                                            placeholder: (provider) => ({
                                                ...provider,
                                                color: '#a0b0ca'
                                            })
                                        }}
                                        // value={UsersTypeValue}
                                        // isOptionDisabled={(option) => option.isdisabled}
                                        // onChange={(e) => onSelect(e)}
                                        options={UsersTypeList}
                                    />
                                    {formik.touched.nationality && formik.errors.nationality ? (
                                        <div className="text-danger">{formik.errors.nationality}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => formik.handleSubmit()}
                                >Submit</button>
                            </div>
                        </form>
                        <Loader isShow={loader} />
                    </div>
                </div>
            </div>
        </div>
    )
}
